<template>
  <div>
    <template v-if="chamber !== 'president'">
      <h4>Is it an open seat?</h4>
      <span v-if="election.openSeat">Yes</span>
      <span v-else>No</span>
    </template>

    <h4 class="mt-3">How partisan is the
      <template v-if="election.chamber === 'HOUSE'">district</template><template v-else>state</template>? (PVI)
    </h4>
    <span :class="[electionJson.pvi.includes('R') ? 'gop' : 'dem', 'bold']">{{ electionJson.pvi }}</span>

    <template v-if="election.previousParty">
      <h4 class="mt-3">Who is the current party?</h4>
      <span v-if="election.previousParty === 'Democratic'" class="dem">Democratic</span>
      <span v-if="election.previousParty === 'Republican'" class="gop">Republican</span>
    </template>

    <template v-if="incumbent">
      <h4 class="mt-3">Who was the previous winner?</h4>
      <span>{{ incumbent.name }} </span>
      <span :class="$options.filters.partyAbbrev(incumbent.party).toLowerCase()">({{ incumbent.party }})</span>
    </template>

    <template v-if="chamber !== 'president'">
      <h4 class="mt-3">Is it an uncontested election?</h4>
      <span v-if="election.uncontested">Yes</span>
      <span v-else>No</span>
    </template>
  </div>
</template>

<script>
const props = {
  chamber: {
    type: String,
    required: true
  },
  election: {
    type: Object,
    required: true
  }
}

const computed = {
  electionJson () {
    return this.election.electionJson
  },
  incumbent () {
    return this.electionJson.incumbent
  }
}

export default {
  props,
  computed
}
</script>
